/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, inject, Input, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {TuiPdfViewerOptions, TuiPdfViewerService} from '@taiga-ui/kit';
import {PolymorpheusContent} from '@taiga-ui/polymorpheus';
import {BaseComponent, DamElasticDTO, DamItemVersion, FileService} from 'compob2b-libs';
import {DamService} from '../../dam.service'

@Component({
    selector: 'app-share-dam-item-version',
    templateUrl: './share-dam-item-versions.component.html',
    styleUrls: ['./share-dam-item-versions.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ShareDamItemVersionsComponent extends BaseComponent implements OnInit {

  @Input() model: DamElasticDTO;
  damItemVersions: DamItemVersion[];
  damService = inject(DamService);

  constructor(protected readonly fileService: FileService,
              protected readonly sanitizer: DomSanitizer,
              protected readonly pdfService: TuiPdfViewerService) {
    super();
  }

  ngOnInit(): void {
    if (this.model)
    this.compoApiService.get<DamItemVersion[]>('/dam/shared-item-version/' + this.model.syncUid).subscribe(response => {
      this.damItemVersions = response.data;
      this.cdr.detectChanges();
    });
  }

  public download(id: number, header: string) {
    window.open(this.environment.serverUrl + '/dam/data/' + this.model.syncUid + '/' + id, '_blank').focus();
  }

  /**
   * @description:
   * Embedded PDFs in mobile doesn't work,
   * so you can use third-party services
   * or your own service to render PDF in mobile iframe
   */
  show(actions: PolymorpheusContent<TuiPdfViewerOptions>, id: number): void {
    this.pdfService
      .open(
        this.sanitizer.bypassSecurityTrustResourceUrl(this.environment.serverUrl + '/dam/data/' + this.model.syncUid + '/' + id), {
          label: 'Dam document',
          actions,
        },
      )
      .subscribe();
  }

}
